import { useEffect, useState } from "react"
import { Container, Grid, Stack, Typography } from "@octopus-energy/coral/atoms"
import { Page, PageLoader } from "@/components/organisms"
import { BlogPostPreview } from "@/features/blog"
import { fetchSbStories } from "../../../../lib/api"
import { type SbBlogCategoryStory, type SbBlogPostStory } from "../../../../types"

type BlogCategoryTemplateProps = {
    story: SbBlogCategoryStory
}

export function BlogCategoryTemplate({ story }: BlogCategoryTemplateProps) {
    const { title } = story.content
    const [stories, setStories] = useState<Array<SbBlogPostStory>>([])
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        const fetchStories = async () => {
            try {
                const stories = await fetchSbStories({
                    starts_with: story.full_slug,
                    excluding_ids: String(story.id),
                    content_type: "blogPost",
                })

                setStories(stories)
            } catch (error) {
                console.error(`Could not find stories with category slug ${story.full_slug}`, error)
            }

            setIsLoading(false)
        }

        void fetchStories()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    if (isLoading) return <PageLoader />

    return (
        <>
            <Page>
                <Stack flexDirection="column">
                    <Container component="header">
                        {" "}
                        <Typography
                            textAlign="center"
                            textStyle="h1"
                        >
                            {title}
                        </Typography>
                    </Container>

                    <Grid
                        gap="sm"
                        gridTemplateColumns={{ base: "1fr", md: "repeat(3, 1fr)" }}
                    >
                        {stories.map((story) => (
                            <BlogPostPreview
                                story={story}
                                key={story.uuid}
                            />
                        ))}
                    </Grid>
                </Stack>
            </Page>
        </>
    )
}
